import { render, staticRenderFns } from "./BackToTopComponent.vue?vue&type=template&id=3a793ffa&scoped=true&"
import script from "./BackToTopComponent.vue?vue&type=script&lang=js&"
export * from "./BackToTopComponent.vue?vue&type=script&lang=js&"
import style0 from "./BackToTopComponent.vue?vue&type=style&index=0&id=3a793ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a793ffa",
  null
  
)

export default component.exports